import { api } from '@bilibili-maoer/web-utils';
import { prependPrefix } from '../../../utils/style.js';
import '@babel/runtime-corejs3/core-js/instance/filter';
import '@babel/runtime-corejs3/core-js/json/stringify';
import '@babel/runtime-corejs3/core-js/instance/reverse';
import '@babel/runtime-corejs3/core-js/instance/slice';
import '@babel/runtime-corejs3/core-js/instance/includes';
import '@babel/runtime-corejs3/core-js/instance/splice';
import '@babel/runtime-corejs3/core-js/instance/index-of';
import 'lodash';

var SEARCH_PAGE_PREFIX = "".concat(api.MISSEVAN_API_PREFIX_URL, "/sound/search");
var SEARCH_ITEM_CLASSNAME = prependPrefix('suggestion-item');
var SEARCH_KEYWORD_CLASSNAME = prependPrefix('suggestion-keyword');
var LEGACY_SEARCH_BOX_CLASSNAME = prependPrefix('legacy-search-box');

export { LEGACY_SEARCH_BOX_CLASSNAME, SEARCH_ITEM_CLASSNAME, SEARCH_KEYWORD_CLASSNAME, SEARCH_PAGE_PREFIX };
